import { useRouter } from "next/router"
import { translations } from "src/helper/translations"
import { isEmpty } from "src/mixins"

function TableCinema({
  className,
  headerClassName,
  bodyClassName,
  data,
  headers,
  id,
}) {
  const Router = useRouter()
  const { locale } = Router
  return (
    <table className={`investors-area-table ${className}`} id={id}>
      <thead className={`investors-area-table__header ${headerClassName}`}>
        <tr>
          {headers?.map((item, i) => (
            <th key={`${className}-header-items-${i}`}>{item.label}</th>
          ))}
        </tr>
      </thead>
      <tbody className={`investors-area-table__body ${bodyClassName}`}>
        {data?.length ? (
          data?.map((item, i) => (
            <tr key={`${className}-body-items-${i}`}>
              {Object.keys(item).map((key, ii) => (
                <td
                  key={`${className}-body-items-key-${ii} ${
                    typeof item[key] === "number" ? "numeric" : ""
                  }`}
                >
                  {/* {!isEmpty(item[key]) ? item[key] : "-"} */}
                  {item[key] || "-"}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={5} className="investors-area-table__empty-state">
              <h4>{translations[`no_data_${locale}`]}</h4>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TableCinema
